import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeMedia = data => {
  const medium = new schema.Entity('media')
  return normalize(data, [medium])
}

const WorkStoreReducer = combineReducers({
  createWorkRequest: createRequestReducer('WORK:CREATE_WORK'),
  createCommentRequest: createRequestReducer('WORK:LEAVE_COMMENT'),
  workFetchRequest: createRequestReducer('WORK:FETCH', { pending: true }),
  updatingWork: createRequestReducer('WORK:UPDATE_WORK'),
  rotatingMediaRequests: createMappedRequestReducer('WORK:ROTATE_IMAGE'),
  uploadMediaRequests: createMappedRequestReducer(
    'WORK:UPLOAD_MEDIA',
    (state, params, status) => ({
      ...state,
      [params.tempId]: { ...status, params }
    }),
    {
      'WORK:CLEAR_FAILED_UPLOADS': state => {
        const requests = { ...state }
        Object.keys(state).forEach(
          key => requests[key].requestError && delete requests[key]
        )
        return { requests }
      }
    }
  ),
  removeMediaRequests: createMappedRequestReducer('WORK:REMOVE_MEDIA'),
  work: createReducer(null, {
    'WORK:FETCH_REQUEST_SUCCESS': (state, { response }) => response.data.work,
    'WORK:UPLOAD_MEDIA_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      media: [...state.media, response.data.medium]
    }),
    'WORK:LEAVE_COMMENT_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      comments: [...state.comments, response.data.comment]
    }),
    'WORK:UPDATE_WORK_REQUEST_SUCCESS': (state, { response }) =>
      response.data.work
  }),
  media: createReducer(null, {
    'WORK:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeMedia(response.data.work.media),
    'WORK:UPLOAD_MEDIA_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      entities: {
        media: {
          ...state.entities.media,
          [response.data.medium.id]: response.data.medium
        }
      },
      result: [...state.result, response.data.medium.id]
    }),
    'WORK:REMOVE_MEDIA_REQUEST_SUCCESS': (state, { params }) => {
      const mediaMap = { ...state.entities.media }
      delete mediaMap[params.id]
      return {
        ...state,
        entities: { media: mediaMap },
        result: state.result.filter(id => id !== params.id)
      }
    },
    'WORK:REORDER_MEDIA': (state, { mediaOrder }) => {
      const mediaMap = { ...state.entities.media }
      mediaOrder.forEach(
        (id, index) => (mediaMap[id] = { ...mediaMap[id], order: index })
      )
      return {
        ...state,
        mediaBackup: { ...state.entities.media },
        entities: {
          media: mediaMap
        }
      }
    },
    'WORK:RESTORE': state => ({
      ...state,
      entities: {
        media: { ...state.mediaBackup }
      }
    }),
    'WORK:ROTATE_IMAGE_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      entities: {
        media: {
          ...state.entities.media,
          [response.data.medium.id]: {
            ...state.entities.media[response.data.medium.id],
            image_url: response.data.medium.image_url
          }
        }
      }
    })
  })
})

export default WorkStoreReducer
